export default "__VITE_ASSET__ed7ff6c4__"